import E from 'wangeditor'
const { BtnMenu } = E
const _this = this
export default class AlertMenu extends BtnMenu {
  constructor (editor) {
    const $elem = E.$(
            `<div class="w-e-menu">
        <i class="nb-html" style="font-size:12px;width24px">源码</i>
      </div>`
    )
    super($elem, editor)
  }

  clickHandler () {
    this.showSource()
    this.tryChangeActive()
  }

  tryChangeActive () {
    // if (_this.isHTML) this.active()
    // else this.unActive()
    this.unActive()
  }

  showSource () {
    const _this = this
    const _editor = _this.editor
    _this.isHTML = !_this.isHTML
    let _source = _editor.txt.html()
    if (_this.isHTML) {
      _source = _source.replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/ /g, '&nbsp;')
    } else {
      _source = _editor.txt.text().replace(/&lt;/ig, '<').replace(/&gt;/ig, '>').replace(/&nbsp;/ig, ' ')
    }
    _editor.txt.html(_source)
  }
}
